<template>
    <el-scrollbar id="page-back-edit-help" :native="false" style="width: 100%;height: 100%;">
        <el-main>
            <div class="form-item">
                <span class="title">标题：</span>
                <el-input
                        placeholder="请输入标题"
                        style="width: 95%;"
                        v-model="inputTitle">
                </el-input>
            </div>
            <div class="content-wrap">
                <quill-editor
                        v-model="content"
                        ref="myQuillEditor"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @change="onEditorChange($event)">
                </quill-editor>
            </div>
            <el-button type="primary" @click="save(false)">保存</el-button>
        </el-main>
    </el-scrollbar>
</template>

<script>
    export default {
        name: "backEditHelp",
        data(){
            return {
                id:'',
                oldTitle:'',
                inputTitle:'',
                oldContent:'',
                content:``,
                editorOption: {
                    // Some Quill options...
                    modules:{
                        toolbar:[
                            ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
                            ['blockquote', 'code-block'],  //引用，代码块
                            [{ 'header': 1 }, { 'header': 2 }],  // 标题，键值对的形式；1、2表示字体大小
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],  //列表
                            [{ 'script': 'sub'}, { 'script': 'super' }], // 上下标
                            [{ 'indent': '-1'}, { 'indent': '+1' }],  // 缩进
                            [{ 'direction': 'rtl' }],    // 文本方向
                            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  //几级标题
                            [{ 'color': [] }, { 'background': [] }],  // 字体颜色，字体背景颜色
                            [{ 'font': [] }],  //字体
                            [{ 'align': [] }], //对齐方式
                            ['clean'], //清除字体样式
                            ['image','video'] //上传图片、上传视频
                        ]
                    },
                    theme:'snow',
                    autoSaveTimer:null,
                }
            }
        },
        mounted() {
            // console.log('this is current quill instance object', this.editor)
            let id = this.$route.query.id ? this.$route.query.id : '';

            // this.autoSaveTimer = setInterval(()=>{
            //     if(this.id&&(this.content!=this.oldContent||this.inputTitle!=this.oldTitle)){
            //         this.save(true);
            //     }
            // },10*1000)
            if(id){
                this.id = id;
                this.$request.helpData({
                    id:id
                }).then(res=>{
                    if(res.status==200){
                        this.inputTitle = res.data.title;
                        this.oldTitle = res.data.title;
                        this.content = res.data.content;
                        this.oldContent = res.data.content;
                    }else {
                        this.requestError(res.status,res.message);
                    }
                },err=>{
                    this.requestFail(err);
                })
            }else {
                // this.$request.addHelp({
                //     title:'默认标题',
                //     content:'<p>默认内容</p>'
                // }).then(res=>{
                //     if(res.status==200){
                //         this.$message({
                //             type: 'success',
                //             message: '创建成功！'
                //         });
                //         this.id = res.data;
                //         this.$router.push({
                //             name:'backEditHelp',
                //             query:{
                //                 id:res.data
                //             }
                //         })
                //     }else {
                //         this.requestError(res.status,res.message);
                //     }
                // },err=>{
                //     this.requestFail(err);
                // })
                console.log('添加');
            }
        },
        methods: {
            onEditorBlur(quill) {
                console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
                console.log('editor change!', quill, html, text)
                this.content = html
            },
            saveContent(id, autoSave) {
                this.$request.editHelp({
                    id:parseInt(id),
                    title:this.inputTitle,
                    content:this.content
                }).then(res=>{
                    if(res.status==200){
                        this.oldTitle = this.inputTitle;
                        this.oldContent = this.content;
                        if(autoSave){
                            console.log('自动保存成功')
                        }else {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                            this.$router.push({ path: 'backHome/backHelpCenter' })
                        }
                    }else {
                        this.requestError(res.status,res.message);
                    }
                },err=>{
                    this.requestFail(err);
                })
            },
            save(autoSave=false){
                if (this.$route.query.id) {
                    // this.$request.editHelp({
                    //     id:parseInt(this.$route.query.id),
                    //     title:this.inputTitle,
                    //     content:this.content
                    // }).then(res=>{
                    //     if(res.status==200){
                    //         this.oldTitle = this.inputTitle;
                    //         this.oldContent = this.content;
                    //         if(autoSave){
                    //             console.log('自动保存成功')
                    //         }else {
                    //             this.$message({
                    //                 type: 'success',
                    //                 message: '保存成功'
                    //             });
                    //             this.$router.push({ path: 'backHome/backHelpCenter' })
                    //         }
                    //     }else {
                    //         this.requestError(res.status,res.message);
                    //     }
                    // },err=>{
                    //     this.requestFail(err);
                    // })
                    this.saveContent(this.$route.query.id, autoSave)
                } else {
                    this.$request.addHelp({
                        title:'默认标题',
                        content:'<p>默认内容</p>'
                    }).then(res=>{
                        if(res.status==200){
                            this.id = res.data;
                            this.saveContent(this.id, autoSave)
                        }else {
                            this.requestError(res.status,res.message);
                        }
                    },err=>{
                        this.requestFail(err);
                    })
                }
            }

        },
        destroyed(){
            clearInterval(this.autoSaveTimer);
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        }
    }
</script>

<style scoped lang="less">
.form-item{
    .title{
        width: 10%;
        max-width: 100px;
        min-width: 50px;
        margin-right: 10px;
    }
}
.content-wrap{
    padding: 50px 0;
    .quill-editor{
        height: 660px;
    }
}
</style>